const emotionCacheProps = {
    key: `emlakstyles`,
    nonce: `EmlakStyles-`
  };
  
  export default emotionCacheProps;